<template>
  <div class="board__persons pt-1">
    <div class="board__person-wrapper" v-if="host">
      <v-icon class="grey lighten-3 grey--text text--lighten-1" left>
        mdi-account-tie
      </v-icon>
      <div class="board__person">
        <h5 class="grey--text">
          {{ $t('board.host') }}
        </h5>
        <p class="mb-0 body-2">{{ host.name }}</p>
      </div>
    </div>
    <div class="board__person-wrapper" v-if="visitor">
      <v-icon class="grey lighten-3 grey--text text--lighten-1" left>
        mdi-account
      </v-icon>
      <div class="board__person">
        <h5 class="grey--text">
          {{
            isVisitType
              ? $t('board.visitor')
              : $t('board.tenant')
          }}
        </h5>
        <p class="mb-0 body-2">{{ visitor }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { visitTypeServices } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'BoardCardPersons',

  props: {
    type: {
      type: String,
    },

    host: {
      type: [Object, String],
    },

    visitor: {
      type: String,
    },
  },

  computed: {
    isVisitType() {
      return visitTypeServices.includes(this.type)
    }
  }
}
</script>
